// extracted by mini-css-extract-plugin
export default {"mCard":"CD-z","image":"DD-z","imageNoBackground":"ED-z","imageHasCategory":"FD-z","fullWidth":"GD-z"};